export var SubGroupConfiguration;
(function (SubGroupConfiguration) {
    SubGroupConfiguration["League"] = "League";
    SubGroupConfiguration["Time"] = "Time";
    SubGroupConfiguration["None"] = "None";
})(SubGroupConfiguration || (SubGroupConfiguration = {}));
//# sourceMappingURL=SubGroupConfiguration.js.map